import { balanceAges, balanceMap } from "../../balanceMap";
import { formatFilterTags } from "molecules/filters/TableFilter/tableFilterUtils";
import { stringFromBasisPoints } from "@vyne-shared/utils/currency";
import type { BulkRequestFilter } from "./compileBulkRequestFilter";

export function getFilterByText(filter: BulkRequestFilter) {
    const filterTags = [];

    // only show text of first filter applied, and if more than one applied, show count after text
    if (filter.agings) {
        filterTags.push(agingFilterTag(filter));
    }
    if (filter.includeOutstandingClaims) {
        filterTags.push("Outstanding claims");
    }
    if (filter.includeActivePaymentPlans) {
        filterTags.push("Payment plans");
    }
    if (typeof filter.minBalance !== "undefined") {
        filterTags.push(minBalanceTag(filter));
    }

    return formatFilterTags(filterTags);
}

// return aging filter tag assuming filter is set
function agingFilterTag(filter: BulkRequestFilter) {
    const selected = filter.agings; // selected aging set has no inherent order
    const agings = balanceAges.filter((age) => selected!.has(age));
    const strings = agings.map((age) => balanceMap[age].title);
    const tag = strings.join(", ");

    return `${tag} days`;
}

// return min balance filter tag assuming filter is set
function minBalanceTag(filter: BulkRequestFilter) {
    const minBalance = filter.minBalance;
    const tag = stringFromBasisPoints(minBalance) + " minimum";

    return tag;
}
